import React, { ChangeEvent, useRef, useState } from "react";

import OnScreenKeyboard from "./OnScreenKeyboard";

const TextInput = (props: {
  id?: string;
  disabled?: boolean;
  placeholder?: string;
  value?: string;
  onChange?: (val: string) => void;
  onScreenKeyboard: boolean;
  className?: string;
  type?: string;
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [keyboardVisible, setKeyboardVisible] = useState(false);

  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    if (props.onChange) {
      props.onChange(e.target.value);
    }
  };

  const onKeyboardChange = (val: string) => {
    if (props.onChange) {
      props.onChange(val);
    }
  };

  const onInputFocus = () => {
    setKeyboardVisible(true);
  };

  const onKeyboardBlur = () => {
    setKeyboardVisible(false);
  };

  return (
    <>
      <input
        ref={inputRef}
        id={props.id ? props.id : ""}
        className={`pyht-text-input ${props.className ? props.className : ""}`}
        disabled={props.disabled}
        placeholder={props.placeholder ?? ""}
        value={props.value}
        onChange={onChange}
        onFocus={() => onInputFocus()}
        type={props.type ? props.type : "text"}
      />
      {props.onScreenKeyboard && (
        <OnScreenKeyboard
          hideOnEnter
          visible={keyboardVisible}
          onChange={onKeyboardChange}
          onBlur={onKeyboardBlur}
          inputRef={inputRef}
        />
      )}
    </>
  );
};

export default TextInput;
